module.exports = __webpack_public_path__ + "img/logo.a1f8b65c.png";